module.exports = __webpack_public_path__ + "img/img_authentication_master.b2c6a698.png";